import { render, staticRenderFns } from "./DocRoles.vue?vue&type=template&id=2f8bf474&"
import script from "./DocRoles.vue?vue&type=script&lang=js&"
export * from "./DocRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports